
    customElements.whenDefined('sp-number-field').then(() => {
        const numberField = document.querySelector('#default');

        numberField.addEventListener('change', (event) => {
            const target = event.target;
            if (isNaN(target.value)) {
                target.value = '42';
            }
        });
    });
